import { cn } from '@/lib/utils';

interface PageHeaderProps {
  /** 소제목(아이브로우) — 예: 'WORKSPACE'. */
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** 우측 액션(버튼·배지). */
  actions?: React.ReactNode;
  className?: string;
}

/** 페이지 헤더 — eyebrow + h1(Admin Kit 관례 text-2xl semibold) + 설명 / 우측 액션. 워크스페이스 전 페이지 상단 공용. */
export function PageHeader({ eyebrow, title, description, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-6 flex flex-wrap items-center justify-between gap-4', className)}>
      <div className="min-w-0 space-y-1">
        {eyebrow && (
          <span className="block text-xs font-semibold tracking-wider text-primary uppercase">
            {eyebrow}
          </span>
        )}
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
